import { useEffect, useState } from "react";
import { API, authFetch } from "@/App";
import { setCollectionAliases } from "./fabricUtils";

// Module-level store so every screen shares one swatch library and refreshes together.
let state = { list: [], byKey: new Map(), byCode: new Map(), aliases: [], loaded: false };
const listeners = new Set();
let inflight = null;

function build(list, aliases) {
  const byKey = new Map();
  const byCode = new Map();
  list.forEach((s) => {
    byKey.set(s.key, s);
    byCode.set(s.code, [...(byCode.get(s.code) || []), s]);
  });
  return { list, byKey, byCode, aliases, loaded: true };
}

const getJson = (url) => authFetch(url).then((r) => (r.ok ? r.json() : Promise.reject()));

export function refreshFabricLibrary() {
  inflight = Promise.all([getJson(`${API}/fabric-swatches`), getJson(`${API}/fabric-aliases`).catch(() => ({ aliases: [] }))])
    .then(([d, a]) => {
      const aliases = a.aliases || [];
      setCollectionAliases(new Map(aliases.map((x) => [x.alias, x.collection])));
      state = build(d.swatches || [], aliases);
      listeners.forEach((l) => l(state));
      return state;
    })
    .catch(() => state)
    .finally(() => { inflight = null; });
  return inflight;
}

export function useFabricLibrary() {
  const [library, setLibrary] = useState(state);
  useEffect(() => {
    listeners.add(setLibrary);
    if (!state.loaded && !inflight) refreshFabricLibrary();
    else setLibrary(state);
    return () => listeners.delete(setLibrary);
  }, []);
  return library;
}

export const swatchImageUrl = (swatch) => `${API}/fabric-swatches/${swatch.swatch_id}/image`;
export const attachmentImageUrl = (orderId, att) => `${API}/orders/${orderId}/attachments/${att.attachment_id}/preview`;

export async function responseError(res, fallback = "Erreur") {
  const data = await res.json().catch(() => null);
  return data?.detail || fallback;
}
